/* eslint-disable import/prefer-default-export */
export function minuteToTimeString(minutes){
  const inHours = minutes / 60
  const currentHours = String(Math.floor(inHours)).padStart(2, 0)
  const currentMinutes = String((inHours % 1) * 60).padStart(2, 0)

  return `${currentHours}:${currentMinutes}:00`
}
